import { BaseEntity, Entity as DecribeEntity } from '@avangard/utils/entity';

import type { SchoolRequisites } from '@modules/types/graphql';

export type Entity = SchoolRequisites | null;

@DecribeEntity('SchoolRequisitesEntity')
class SchoolRequisitesEntity extends BaseEntity {
    inn: string;
    kpp: string;
    ogrn: string;
    address: string;
    licence: string;
    responsibleName: string;
    responsiblePhone: string;
    responsibleEmail: string;
    signerName: string;
    signerNameGenitive: string;
    signerPosition: string;
    signerPositionGenitive: string;

    constructor(schoolRequisites: Entity) {
        super(schoolRequisites);

        this.inn = schoolRequisites?.inn ?? '';
        this.kpp = schoolRequisites?.kpp ?? '';
        this.ogrn = schoolRequisites?.ogrn ?? '';
        this.address = schoolRequisites?.address ?? '';
        this.licence = schoolRequisites?.licence ?? '';
        this.responsibleName = schoolRequisites?.responsibleName ?? '';
        this.responsiblePhone = schoolRequisites?.responsiblePhone ?? '';
        this.responsibleEmail = schoolRequisites?.responsibleEmail ?? '';
        this.signerName = schoolRequisites?.signerName ?? '';
        this.signerNameGenitive = schoolRequisites?.signerNameGenitive ?? '';
        this.signerPosition = schoolRequisites?.signerPosition ?? '';
        this.signerPositionGenitive = schoolRequisites?.signerPositionGenitive ?? '';
    }
}

export { SchoolRequisitesEntity };
